import { BUSINESS_TYPE } from "../../config/constant";
import PaymentService from "../../service/paymentService";
import secureStorage from "../../config/encrypt";

export const entityUniqueBankKey = () => {
  return `${BUSINESS_TYPE}_bankList`;
}

export const fetchAndSetBankList = async () => {
  try {
    const payload = {
      entity_source: ['oto','fav','triv','emp']//[BUSINESS_TYPE]
    };

    const response = await PaymentService.getTenantBankList(payload);
    if (response && response.status === 200) {
      const bankList = response.data && response.data?.data || [];
      const entityUniqueKey = entityUniqueBankKey();

      secureStorage.setItem(entityUniqueKey, bankList);

      return {
        status: 200,
        message: 'success',
        data: bankList,
      };
    } else {
      return {
        status: response.status,
        message: response?.message,
        data: [],
      };
    }
  } catch (error) {
    throw error;
  }
};

export const getEntityBankList = async () => {
  await fetchAndSetBankList();
  return secureStorage.getItem(entityUniqueBankKey());
}

export const getLocalBankList = () => {
  return secureStorage.getItem(entityUniqueBankKey());
}